import axios from 'axios';
import { endpoints } from '@/api/endpoints.js';
import { baseURL } from '../../../api/environment';

const URL = baseURL;

/**
 * Genera el código de barras para pago en efectivo
 */
export const generateBarcode = async ({ commit, rootState }) => {
    try {
        commit('SET_LOADING', true);
        const token = rootState.Token.token.dataObj;
        const telefono = rootState.Users.user_contact.telefono;
        const endpoint = endpoints.checkout.generateBarcode.endpoint;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                telefono: telefono
            }
        });
        
        commit('SET_BARCODE', data.dataObj);
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Envía la referencia de pago por SMS
 */
export const sendReferencePayment = async ({ commit, rootState }) => {
    try {
        commit('SET_LOADING', true);
        const token = rootState.Token.token.dataObj;
        const telefono = rootState.Users.user_contact.telefono;
        const endpoint = endpoints.checkout.sendReferencePayment.endpoint;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                telefono: telefono
            }
        });
        
        if (data.dataObj.statusCode == 1200) {
            commit('SET_ERROR_SUBSCRIPTION', data.dataObj.message);
        } else {
            commit('SET_BARCODE_REFERENCE', data);
        }
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Obtiene el precio para pago en efectivo
 */
export const getEffectivoPrice = async ({ commit, rootState }) => {
    try {
        commit('SET_LOADING', true);
        commit('LOADING_PACKAGES', true);

        const token = rootState.Token.token.dataObj;
        const postal_code = rootState.Subscription.user_registration.postalCode;
        const endpoint = endpoints.checkout.subscribeEffectivo.endpoint;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token,
            },
            data: {
                cp: postal_code
            }
        });

        if (Object.keys(data.dataObj.datos).length != 0) {
            if (data.dataObj.codigo == 222) {
                commit('SET_ERROR_SUBSCRIPTION', data.dataObj.mensaje_respuesta);
                commit('SET_LOADING', false);
                return false;
            } else {
                if (Object.keys(data.dataObj.datos).length != 0) {
                    commit('SET_EFFECTIVO_PRICE', data.dataObj.datos);
                    return true;
                } else {
                    return false;
                }
            }
        } else {
            commit('SET_ERROR_SUBSCRIPTION', data.dataObj.mensaje);
            return false;
        }
    } catch (err) {
        commit('SET_LOADING', false);
        commit('LOADING_PACKAGES', false);
    } finally {
        commit('SET_LOADING', false);
        commit('LOADING_PACKAGES', false);
    }
};

/**
 * Obtiene la suscripción para pago en efectivo
 */
export const getSuscriptionEfective = async ({ commit, rootState }) => {
    try {
        commit('SET_LOADING', true);
        commit('LOADING_PACKAGES', true);

        const token = rootState.Token.token.dataObj;
        const idPaquete = rootState.Products.information.producto;
        const pago = "Efectivo";
        const endpoint = endpoints.packages.getDataSuscription.endpoint;

        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token,
            },
            data: {
                idPaquete: idPaquete,
                pago: pago
            }
        });

        if (Object.keys(data.dataObj.datos).length != 0) {
            if (data.dataObj.codigo == 222) {
                commit('SET_ERROR_SUBSCRIPTION', data.dataObj.mensaje_respuesta);
                commit('SET_LOADING', false);
                return false;
            } else {
                if (Object.keys(data.dataObj.datos).length != 0) {
                    commit('SET_SUSCRIPTION_EFECTIVE', data.dataObj.total);
                    return true;
                } else {
                    return false;
                }
            }
        } else {
            commit('SET_ERROR_SUBSCRIPTION', data.dataObj.mensaje);
            return false;
        }
    } catch (err) {
        console.log(err);
        commit('SET_LOADING', false);
        commit('LOADING_PACKAGES', false);
    } finally {
        commit('SET_LOADING', false);
        commit('LOADING_PACKAGES', false);
    }
};

/**
 * Guarda la suscripción en efectivo
 */
export const saveSuscEfectivo = async ({ commit }, params) => {
    try {
        commit('SET_SUSC_EFECTIVO', params);
    } catch (err) {
        commit('SET_ERROR', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};
